import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/operator/startWith';
import'rxjs/add/operator/map';
/**
 * \@title Filter autocomplete
 */
export class AutocompleteFilterExample {

  myControl: FormControl = new FormControl();

  options = [
    'One',
    'Two',
    'Three'
  ];

  filteredOptions: Observable<string[]>;
/**
 * @return {?}
 */
ngOnInit() {
      this.filteredOptions = this.myControl.valueChanges
         .startWith(null)
         .map(val => val ? this.filter(val) : this.options.slice());
   }
/**
 * @param {?} val
 * @return {?}
 */
filter(val: string): string[] {
      return this.options.filter(option =>
        option.toLowerCase().indexOf(val.toLowerCase()) === 0);
   }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'autocomplete-filter-example',
  templateUrl: 'autocomplete-filter-example.html',
  styleUrls: ['autocomplete-filter-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutocompleteFilterExample_tsickle_Closure_declarations() {
/** @type {?} */
AutocompleteFilterExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutocompleteFilterExample.ctorParameters;
/** @type {?} */
AutocompleteFilterExample.prototype.myControl;
/** @type {?} */
AutocompleteFilterExample.prototype.options;
/** @type {?} */
AutocompleteFilterExample.prototype.filteredOptions;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
